import * as React from 'react'
export default function Contact() {
  return (
    <div className="bg-white text-slate-800 antialiased">
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="text-4xl font-semibold tracking-tight text-primary">
            prevew
          </a>

          <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">
            <a href="/#how-it-works" className="hover:text-primary transition cursor-pointer">
              How it works
            </a>
            <a href="/#benefits" className="hover:text-primary transition">
              Benefits
            </a>
            {/* <a href="#for-recruiters" className="hover:text-primary transition">
              Recruiters
            </a>
            <a href="#for-candidates" className="hover:text-primary transition">
              Candidates
            </a> */}
            <a href="/contact" className="hover:text-primary transition">
              Contact
            </a>
          </nav>

          <button className="inline-flex px-5 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition">
            Get early access
          </button>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent"></div>

        <div className="relative max-w-7xl mx-auto px-6 pt-28 pb-20">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-semibold tracking-tight leading-tight">
              Let’s talk.
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Questions, feedback, partnerships, or just curious about prevew? We’re real people
              building this — and we’d love to hear from you.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 rounded-2xl bg-white border border-slate-200">
              <h3 className="text-lg font-medium">Sales & partnerships</h3>
              <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                Hiring at scale? Interested in piloting prevew with your team? Let’s explore what
                makes sense.
              </p>
              <p className="mt-4 text-sm font-medium text-primary">sales@prevew.com</p>
            </div>

            <div className="p-6 rounded-2xl bg-white border border-slate-200">
              <h3 className="text-lg font-medium">Support & questions</h3>
              <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                Stuck, confused, or something not working as expected? We’ll help you get sorted.
              </p>
              <p className="mt-4 text-sm font-medium text-primary">support@prevew.com</p>
            </div>

            <div className="p-6 rounded-2xl bg-white border border-slate-200">
              <h3 className="text-lg font-medium">General hello</h3>
              <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                Ideas, feedback, or just want to say hi? We read everything.
              </p>
              <p className="mt-4 text-sm font-medium text-primary">hello@prevew.com</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-28">
        <div className="max-w-3xl mx-auto px-6">
          <div className="rounded-3xl border border-slate-200 p-10 bg-white">
            <h2 className="text-2xl font-semibold tracking-tight">Send us a message</h2>

            <p className="mt-4 text-slate-600 leading-relaxed">
              Fill this out and we’ll get back to you soon. No bots. No black hole.
            </p>

            <form className="mt-10 space-y-6">
              <div>
                <label className="block text-sm font-medium text-slate-700">Name</label>
                <input
                  type="text"
                  placeholder="Jane Doe"
                  className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700">Email</label>
                <input
                  type="email"
                  placeholder="jane@company.com"
                  className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700">Message</label>
                <textarea
                  rows={5}
                  placeholder="Tell us what’s on your mind…"
                  className="mt-2 w-full rounded-lg border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40"
                ></textarea>
              </div>

              <div className="pt-4">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-7 py-3 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary/90 transition"
                >
                  Send message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <footer className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-sm text-slate-500">© 2025 prevew. All rights reserved.</div>

          <div className="flex items-center gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-primary transition">
              Privacy
            </a>
            <a href="#" className="hover:text-primary transition">
              Terms
            </a>
            <a href="/contact.html" className="hover:text-primary transition">
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}
